import { RegisterComponent } from './pages/register/register.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from '@pages/dashboard/dashboard.component';
import { LoginComponent } from '@pages/login/login.component';
import { RecoveryPasswordComponent } from '@pages/recoveryPassword/recoveryPassword.component';
import { LoginGuard } from '@shared/guards/login.guard';
import { SessionGuard } from './shared/guards/session.guard';
import { SocietyListComponent } from './pages/users/society-list/society-list.component';
import { UserListComponent } from './pages/users/user-list/user-list.component';
import { ReservationListComponent } from './pages/reservations/reservation-list/reservation-list.component';
import { CarSharingComponent } from "./pages/carsharing/carsharing.component"
import { VirementsListComponent } from './pages/facturations/virements-list/virements-list.component';
import { GainComponent } from './pages/facturations/gain/gain.component';
import { ControlComponent } from './pages/facturations/control/control.component';
import { MyReservationComponent } from './pages/reservations/reservation-me/reservation-me.component';
import { VehicleListComponent } from './pages/ressources/vehicle-list/vehicle-list.component';
import { SinisterListComponent } from './pages/reservations/sinister-list/sinister-list.component';
import { StationListComponent } from './pages/ressources/station-list/station-list.component';
import { VehicleInformationsComponent } from './pages/ressources/vehicle-informations/vehicle-informations.component';
import { StationInformationsComponent } from './pages/ressources/station-informations/station-informations.component';
import { UserInformationsComponent } from './pages/users/user-informations/user-informations.component';
import { SocietyInformationsComponent } from './pages/users/society-informations/society-informations.component';
import { ReservationInformationsComponent } from './pages/reservations/reservation-informations/reservation-informations.component';
import { ReservationInvoicesComponent } from './pages/reservations/reservation-invoices/reservation-invoices.component';
import { VehicleLogsComponent } from './pages/ressources/vehicle-logs/vehicle-logs.component';
import { CompanyInformationsComponent } from './pages/companies/company-informations/company-informations.component';
import { MapComponent } from './components/map/map.component';

const routes: Routes = [
  /*
    Dashboard
  */
  {
    path: '', component: DashboardComponent,
    canActivate: [SessionGuard], data: { roles: ['admin', 'super-admin'], animation: 'DashboardPage' },
  },
  {
    path: 'carte', component: MapComponent,
    canActivate: [SessionGuard], data: { roles: ['super-admin'], animation: 'DashboardPage' },
  },
  /*
    Companies
  */
  {
    path: 'company/informations', component: CompanyInformationsComponent,
    canActivate: [SessionGuard], data: { roles: ['super-admin', 'admin'], animation: 'CompanyInformationsPage' }
  },
  /*
    Reservations
  */
  {
    path: 'reservation/list', component: ReservationListComponent,
    canActivate: [SessionGuard], data: { roles: ['super-admin', 'admin'], animation: 'ReservationListPage' }
  },
  {
    path: 'reservation/informations/:id', component: ReservationInformationsComponent,
    canActivate: [SessionGuard], data: { roles: ['super-admin', 'admin'], animation: 'ReservationInformationsPage' }
  },
  {
    path: 'reservation/sinister/list', component: SinisterListComponent,
    canActivate: [SessionGuard], data: { roles: ['super-admin', 'admin'], animation: 'AlertListPage' }
  },
  {
    path: 'reservation/invoices/list', component: ReservationInvoicesComponent,
    canActivate: [SessionGuard], data: { roles: ['super-admin'], animation: 'ListPage' }
  },
  /*
  carsharing
  */
  {
    path: 'carsharing/list', component: CarSharingComponent,
    canActivate: [SessionGuard], data: { roles: ['super-admin'], animation: 'ReservationListPage' }
  },
  /*
  Facturation
   */
  {
    path: 'facturation/virements', component: VirementsListComponent,
    canActivate: [SessionGuard], data: { roles: ['super-admin', 'admin'], animation: 'ReservationListPage' }
  },
  {
    path: 'facturation/gain', component: GainComponent,
    canActivate: [SessionGuard], data: { roles: ['super-admin', 'admin'], animation: 'ReservationListPage' }
  },
  {
    path: 'facturation/controle', component: ControlComponent,
    canActivate: [SessionGuard], data: { roles: ['super-admin', 'admin'], animation: 'ReservationListPage' }
  },

  /* 
    Users
  */
  {
    path: 'user/society/list', component: SocietyListComponent,
    canActivate: [SessionGuard], data: { roles: ['super-admin'], animation: 'SocietyListPage' }
  },
  {
    path: 'user/society/informations/:id', component: SocietyInformationsComponent,
    canActivate: [SessionGuard], data: { roles: ['super-admin', 'admin'], animation: 'SocietyInformationsPage' }
  },
  {
    path: 'user/list', component: UserListComponent,
    canActivate: [SessionGuard], data: { roles: ['super-admin', 'admin'], animation: 'UserListPage' }
  },
  {
    path: 'user/informations/:id', component: UserInformationsComponent,
    canActivate: [SessionGuard], data: { roles: ['super-admin', 'admin'], animation: 'UserInformationsPage' }
  },
  /* 
    Ressources
  */
  {
    path: 'user/me', component: UserInformationsComponent,
    canActivate: [SessionGuard], data: { roles: ['user'], animation: 'UserInformationsPage' }
  },
  {
    path: 'reservation/me', component: MyReservationComponent,
    canActivate: [SessionGuard], data: { roles: ['user'], animation: 'UserInformationsPage' }
  },
  /* 
    Ressources
  */
  {
    path: 'ressource/vehicle/list', component: VehicleListComponent,
    canActivate: [SessionGuard], data: { roles: ['super-admin', 'admin'], animation: 'VehicleListPage' }
  },
  {
    path: 'ressource/vehicle/informations/:id', component: VehicleInformationsComponent,
    canActivate: [SessionGuard], data: { roles: ['super-admin', 'admin'], animation: 'VehicleInformationsPage' }
  },
  {
    path: 'ressource/vehicle/logs/:id', component: VehicleLogsComponent,
    canActivate: [SessionGuard], data: { roles: ['super-admin'], animation: 'VehicleLogsPage' }
  },
  {
    path: 'ressource/station/list', component: StationListComponent,
    canActivate: [SessionGuard], data: { roles: ['super-admin', 'admin'], animation: 'StationListPage' }
  },
  {
    path: 'ressource/station/informations/:id', component: StationInformationsComponent,
    canActivate: [SessionGuard], data: { roles: ['super-admin', 'admin'], animation: 'StationInformationsPage' }
  },
  /*
    Others
  */
  {
    path: 'login', component: LoginComponent,
    canActivate: [LoginGuard], data: { roles: ['super-admin', 'admin'], animation: 'LoginPage' }
  },
  {
    path: 'register', component: RegisterComponent,
    canActivate: [LoginGuard], data: { roles: ['super-admin', 'admin'], animation: 'LoginPage' }
  },
  {
    path: 'reset-password', component: RecoveryPasswordComponent
  },
  {
    path: '**', redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
